import {SunIcon} from "lucide-react";

function FullscreenLoading({flex, withBg, className}: { flex?: boolean, withBg?: boolean, className?: string }) {
    return (
        <div
            className={`flex items-center justify-center ${withBg ? 'bg-background' : ''} ${flex ? "flex-1" : "w-screen h-dvh"} ${className}`}>
            <SunIcon size={64} className="animate-spin text-brand-400"/>
        </div>
    )
}

export default FullscreenLoading
